import React from "react";
import { useId } from "../../hooks/use-id";
import { FormMessage } from "../../components/shared/form-message";

/**
 * Campo de selección de municipio para el formulario institucional.
 *
 * Renderiza un listado de municipios recibido mediante `options`,
 * registra el campo en React Hook Form y muestra el mensaje de error
 * cuando la validación del campo falla.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formController - Instancia de React Hook Form utilizada para registrar y validar el campo.
 * @param {Object} props.texts - Objeto con los textos traducidos utilizados en la interfaz.
 * @param {Array<string>} props.options - Lista de municipios disponibles para seleccionar.
 *
 * @returns {JSX.Element} Campo de selección de municipio.
 */
export const InstMunicipalityField = ({
    formController,
    texts,
    options = []
}) => {
    const municipio = useId("municipio");
    const fieldMunicipality = "ciudad";

    const { institucional } = texts;
    const { form } = institucional;

    const {
        register,
        formState: { errors }
    } = formController;

    return (
        <>
            <label
                htmlFor={municipio}
                className="secondary-item"
            >
                <strong>
                    {form?.municipio?.label || "Municipio:"}
                </strong>
            </label>

            <select
                className="form-control focusable-secondary"
                id={municipio}
                {...register(fieldMunicipality, {
                    required: {
                        value: true,
                        message:
                            form?.municipio?.alert ||
                            "Por favor, escoge un municipio"
                    }
                })}
            >
                <option hidden value="">
                    {form?.municipio?.placeholder || "Escoge tu municipio"}
                </option>

                {options.map((item) => (
                    <option key={item} value={item}>
                        {item}
                    </option>
                ))}
            </select>

            <FormMessage
                message={errors[fieldMunicipality]?.message}
                type="error"
            />
        </>
    );
};